<template>
  <v-toolbar-items>
    <v-menu offset-y left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" text>
          <v-icon color="gray-6">account_circle</v-icon>
          <span class="text--capitalize ml-1 d-none d-sm-flex d-xs-flex">{{ name }}</span>
          <v-icon color="gray-6" right small>keyboard_arrow_down</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-if="hasRole('user', 'ROLE_POST_FORGOTPASSWORD')"
          @click="handleResetPassword"
        >
          <v-list-item-title>{{ $t(`${namespace}.resetPassword`) }}</v-list-item-title>
        </v-list-item>

        <v-list-item @click="logoutSession">
          <v-list-item-title>{{ $t(`${namespace}.logout`) }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-toolbar-items>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import session from '@/services/modules/session'
import { hasRole } from 'utils/functions'
import { catchError } from 'corp-front-vue-commons/src/utils/functions'

export default {
  name: 'UserDropdownMenu',
  computed: {
    ...mapState({
      name: ({ session }) => session.user.business.name,
      email: ({ session }) => session.user.business.email
    })
  },
  data () {
    return {
      namespace: 'Components.UserDropdownMenu'
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    hasRole (group, role) {
      return hasRole(group, role)
    },

    async handleResetPassword () {
      try {
        await session.forgotPassword(this.email)
        this.showAlert({
          type: 'success',
          message: this.$t(`${this.namespace}.sendEmailSuccess`)
        })
      } catch (error) {
        catchError(error)
        this.loggedIn && this.showAlert({
          type: 'error',
          message: this.$t('Common.genericError')
        })
      }
    },

    redirectToLogin () {
      this.$router.push({ name: 'Login' }).catch(e => {})
    },

    logoutSession () {
      session.logout()
      this.redirectToLogin()
    }
  }
}
</script>
